angular.module('chat2')
.component('messageActionButton', {
    bindings: {
        message: '=',
        allowDelete: '=',
        showEllipsis: "=",
        deleteCallback: "=",
        teamAvatar: '<',
        avatar: '<'
     },
    controller: [ "$uibModal", "$scope", "$document","portalConfig",
        
        function ($uibModal, $scope, $document,portalConfig){
            var ctrl = this;
            ctrl.$onInit = function(){
                if(ctrl.message){
                    var message = ctrl.message.message ? ctrl.message.message : ctrl.message;
                    var parts = message.parts ? message.parts : message.messageParts;
    
                    ctrl.alreadyRedacted = parts && parts.length === 1 && portalConfig.redactedMessageData === parts[0].data;
                }
            }
         
            ctrl.showDelete = false;

            ctrl.popoverDelete = {
                templateUrl: 'components/toolkit/chat/templates/messageActionPopover.html',
            }; 

            ctrl.closePop = function(){
                if(ctrl.isOpen){
                    ctrl.isOpen = false; 
                    $scope.$apply();
                }
            }

            ctrl.onDestroy= function(){
                if(parentElement && parentElement.removeEventListener){
                    parentElement.removeEventListener("scroll", ctrl.closePop);
                }
            }

            function getScrollParent(node) {
                if (node == null) {
                  return null;
                }
                if (node.scrollHeight > node.clientHeight) {
                  return node;
                } else {
                  return getScrollParent(node.parentNode);
                }
              }

            var element = $document[0].getElementById("scrollWindow");
            var parentElement =  getScrollParent(element);
            if(parentElement && parentElement.addEventListener){
                parentElement.addEventListener("scroll", ctrl.closePop);
            }

            ctrl.open = function () {
                ctrl.isOpen = false;
                var modalInstance = $uibModal.open({
                    templateUrl: 'components/toolkit/chat/templates/delete-message-modal.html',
                    controller: 'deleteMessageModal',
                    size: 'md',
                    resolve: {
                        message: function () {
                            return ctrl.message.message ? ctrl.message.message : ctrl.message;
                        },
                        direction: function(){
                            if(ctrl.message.direction){
                                return ctrl.message.direction;
                            }
                            else{
                                return ctrl.message.senderId.startsWith("PLATFORMUSER") ? 'outbound' : 'inbound';
                            }
                        },
                        teamAvatar: function(){
                            return ctrl.teamAvatar;
                        },
                        avatar: function(){
                            return ctrl.avatar;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    ctrl.deleteCallback(ctrl.message);
                }, function () {
                    // $log.info('Modal dismissed at: ' + new Date());
                });
            };


        }
    
    ],
    
    templateUrl: 'components/toolkit/chat/templates/messageActionButtonTemplate.html'
})
.controller('deleteMessageModal', ['$scope', '$uibModalInstance', 'message', 'direction', 'avatar', 'teamAvatar', 
    function($scope, $uibModalInstance, message, direction, avatar, teamAvatar){
    $scope.message = angular.copy(message);
    $scope.direction = direction;
    $scope.teamAvatar = teamAvatar;
    if($scope.teamAvatar){
        if($scope.direction === 'inbound'){
            $scope.teamAvatar = './assets/img/avatar.svg';
        }
    }
    $scope.avatar = avatar;
    $scope.message.parts = $scope.message.parts ? $scope.message.parts : $scope.message.messageParts;
    
    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.ok = function(){
        $uibModalInstance.close();   
    } 
}]);